<template>
  <v-breadcrumbs :items class="pa-0 mb-0" />
</template>

<script setup lang="ts">
import type { WpTerm } from '~/types';
import { VBreadcrumbs } from "vuetify/components";
import { buildBlogCategoryPath } from '~/helpers/routing';

const props = defineProps<{
  current: string;
  category?: WpTerm;
}>();

const { tt } = useLocalization();

const items: VBreadcrumbs['$props']['items'] = [
  { title: tt('blog.blog'), disabled: false, href: '/blog' },
  { title: props.current }
];

if (props.category) {
  items.splice(1, 0, { title: props.category.name, href: buildBlogCategoryPath(props.category.slug) });
}
</script>

<style scoped>
.v-breadcrumbs {
  align-items: start;
}
:deep(.v-breadcrumbs-item), :deep(.v-breadcrumbs-divider) {
  margin: 0;
}
@media (max-width: 850px) {
  :deep(.v-breadcrumbs-item) {
    font-size: 12px;
  }
}
</style>